import { mlsProviderIds } from 'constants/mlsProviderIds';

/** Knoxville / ETNR feed M00000582. */
const ETNR_PROVIDER_ID = mlsProviderIds.expportal_knoxville;

export type ListingMlsStatusInput = {
  providerId?: number | null;
  mlsStatus?: string | null;
};

/**
 * MlsStatus is an alternate status field supplied by an MLS to add detail beyond
 * StandardStatus. East Tennessee REALTORS® (ETNR, M00000582) currently
 * requires the value to explain the status in more detail such as: Pending - Inspection, Pending- Financing etc. Other MLSs may adopt this
 * RESO field in future.
 * REF: https://dd.reso.org/DD2.0/Property/MlsStatus/
 */
export function getListingMlsStatus({
  providerId,
  mlsStatus,
}: ListingMlsStatusInput): string | null {
  if (providerId !== ETNR_PROVIDER_ID) {
    return null;
  }

  const detailed = mlsStatus?.trim() ?? '';
  return detailed.length > 0 ? detailed : null;
}
